function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTestObjectInactive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("line", {
    x1: 13.4,
    y1: 15.6,
    x2: 16.14,
    y2: 12.86,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.14,12.86l7.43-7.43a1.83,1.83,0,0,0-1.49-.63H19.2a1,1,0,0,1-1-1,3.84,3.84,0,1,0-7.68,0h0a1,1,0,0,1-1,1H6.72A1.79,1.79,0,0,0,4.8,6.72V9.6h0a1,1,0,0,1-1,1,3.84,3.84,0,0,0,0,7.68h0a1,1,0,0,1,1,1v2.88a1.86,1.86,0,0,0,.65,1.47l8-8Z",
    style: {
      fill: "#d2e1fa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4,15.6l-7.95,8A2,2,0,0,0,6.72,24H22.08A1.77,1.77,0,0,0,24,22.08V19.2a1.46,1.46,0,0,0-1-1.48,3.84,3.84,0,0,1,0-6.65A1.46,1.46,0,0,0,24,9.6V6.72a2,2,0,0,0-.43-1.29l-7.43,7.43Z",
    style: {
      fill: "#b4cefa"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestObjectInactive);
export default __webpack_public_path__ + "static/media/test-object-inactive.5d764d5105a750ceb4ce6871f8d67e80.svg";
export { ForwardRef as ReactComponent };